export const LAYER_DATA: number[][] = [
    [ 1, 1, 1, 1 ],
    [ 3, 1, 2, 2, 3 ],
    [ 1, 2, 2, 1, 2 ],
];
